import { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";

import { Box, Button, Stack } from "@mui/material";

import ChildSelector from "../ChildSelector";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear } from "@fortawesome/pro-light-svg-icons";
import { pinwheelPalette } from "../../styles/theme";

import "./navigation.sass";
import { Notification } from "../NotificationCenter";

const MobileHeader = () => {
  const [isNewVersion, setIsNewVersion] = useState(true);
  const navigate = useNavigate();
  const mobileHeaderRef = useRef<HTMLDivElement | null>(null);

  if (isNewVersion) {
     
    localStorage.setItem("appVersion", import.meta.env.VITE_VERSION!);
    setTimeout(() => {
      setIsNewVersion(false);
    }, 3000);
  }

  useEffect(() => {
    if (mobileHeaderRef.current) {
      mobileHeaderRef.current.addEventListener("touchmove", (e) => {
        e.preventDefault();
      });
    }
  }, []);

  return (
    <>
      <Box
        component="nav"
        data-testid="mobile-header"
        className="navbar"
        sx={{
          borderBottom: `1px solid ${pinwheelPalette.grey[5]}`,
          minHeight: { lg: "100vh" },
        }}
        ref={mobileHeaderRef}
      >
        <Box
          component="div"
          sx={{
            display: { xs: "flex", lg: "none" },
          }}
          className="navbar-mobile"
        >
          <div className="navbar-brand-child-selector">
            <NavLink className="navbar-item logo" to="/">
              &nbsp;
            </NavLink>
            <div className="childSection">
              <ChildSelector />
            </div>
          </div>
          <Stack direction="row" justifyContent="space-between" alignItems="center" gap="8px">
            <Notification />
            <Button
              color="inherit"
              variant="text"
              sx={{ minWidth: 40, minHeight: 40 }}
              onClick={() => {
                navigate("/settings/account");
              }}
              data-testid="mobile-header-settings-button"
            >
              <FontAwesomeIcon icon={faGear} style={{ fontSize: "24px" }} />
            </Button>
          </Stack>
        </Box>
      </Box>
    </>
  );
};

export default MobileHeader;
